<template>
  <v-menu location="bottom">
    <template #activator="{ props: menuProps }">
      <v-btn
        variant="flat"
        class="btn-refresh toolbar-report-menu-btn"
        size="small"
        v-bind="menuProps"
      >
        <v-icon size="14">mdi-file-chart-outline</v-icon>
        보고서
        <v-icon size="14">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact" class="wage-report-menu-list">
      <v-list-subheader class="wage-report-menu-subheader">임금대장</v-list-subheader>
      <v-list-item
        v-if="canViewAccountingReport"
        :disabled="savedWageCount === 0"
        @click="emit('accounting-report')"
      >
        <v-list-item-title>회계처리용</v-list-item-title>
      </v-list-item>
      <v-list-item :disabled="savedWageCount === 0" @click="emit('client-report')">
        <v-list-item-title>임금대장</v-list-item-title>
      </v-list-item>
      <v-divider class="wage-report-menu-divider" />
      <v-list-item :disabled="slipDisabled" @click="emit('wage-slip')">
        <v-list-item-title>{{ slipLabel }}</v-list-item-title>
      </v-list-item>
      <v-divider class="wage-report-menu-divider" />
      <template v-if="showNontaxSection">
        <v-list-subheader class="wage-report-menu-subheader">임금개선</v-list-subheader>
        <v-list-item :disabled="savedWageCount === 0" @click="emit('nontax-monthly')">
          <v-list-item-title>월별 분석</v-list-item-title>
        </v-list-item>
        <v-list-item @click="emit('nontax-yearly')">
          <v-list-item-title>연간 분석</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="isAdmin">
        <v-divider class="wage-report-menu-divider" />
        <v-list-item :disabled="employeeCount === 0" @click="emit('transaction')">
          <v-list-item-title class="wage-report-menu-item-with-chip">
            거래명세서
            <span class="admin-only-chip">관리자</span>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="isSuperAdmin">
        <v-divider class="wage-report-menu-divider" />
        <v-list-subheader class="wage-report-menu-subheader">점검</v-list-subheader>
        <v-list-item
          :disabled="savedWageCount === 0"
          @click="emit('retirement-compare')"
        >
          <v-list-item-title class="wage-report-menu-item-with-chip">
            퇴직금 비교
            <span class="admin-only-chip admin-only-chip--super">최고관리자</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    savedWageCount?: number;
    employeeCount?: number;
    canViewAccountingReport?: boolean;
    showNontaxSection?: boolean;
    slipDisabled?: boolean;
    slipLabel?: string;
    isAdmin?: boolean;
    /** role_level >= 100 */
    isSuperAdmin?: boolean;
  }>(),
  {
    savedWageCount: 0,
    employeeCount: 0,
    canViewAccountingReport: false,
    showNontaxSection: true,
    slipDisabled: true,
    slipLabel: '명세서 PDF',
    isAdmin: false,
    isSuperAdmin: false,
  }
);

const emit = defineEmits<{
  'accounting-report': [];
  'client-report': [];
  'wage-slip': [];
  'nontax-monthly': [];
  'nontax-yearly': [];
  transaction: [];
  'retirement-compare': [];
}>();
</script>
